import React from "react";
import type { ThgPayoutTotals, ThgStateTotal } from "../../../types/thgAnnualSummary";
import { formatEur } from "../utils/thgFormat";
import { PAYOUT_COPY } from "../ThgAnnualSummary.consts";

interface PayoutTotalsProps {
  totals: ThgPayoutTotals;
}

const stations = (n: number) => `${n} ${n === 1 ? "station" : "stations"}`;

const Block: React.FC<{ label: string; count: number; total?: ThgStateTotal }> = ({ label, count, total }) => (
  <div className="thg-payout-total flex flex-column gap-1 p-2 border-round" data-testid={`thg-payout-total-${label}`}>
    <span className="text-sm text-color-secondary">{label}</span>
    <span className="font-semibold">{stations(count)}</span>
    {total && (
      <span className="text-sm white-space-nowrap">
        {PAYOUT_COPY.totalsNetGross(formatEur(total.netEur), total.grossEur === null ? null : formatEur(total.grossEur))}
      </span>
    )}
  </div>
);

/**
 * The year's payout run at a glance (CLR-283). The backend's figures, never summed on screen: final and draft
 * amounts come from the credit notes, "not generated" is the summary payout and has no gross, since VAT is
 * known only once a draft exists.
 */
const PayoutTotals: React.FC<PayoutTotalsProps> = ({ totals }) => (
  <div className="flex flex-wrap gap-3 mb-3" aria-label="Payout totals">
    <Block label="Final" count={totals.final.count} total={totals.final} />
    <Block label="Draft" count={totals.draft.count} total={totals.draft} />
    <Block label="Not generated" count={totals.notGenerated.count} total={totals.notGenerated} />
    <Block label="Not payable" count={totals.notPayable} />
  </div>
);

export default PayoutTotals;
